import { Box, Collapse, Typography } from "@mui/material";
import { useState } from "react";
import useColors from "../../../../../api/hooks/useColors";
import SvgToIcon from "../../../../../icons/SvgToIcon";
import { ReactComponent as ChevronDownIcon } from "../../../../stack/environment/icons/chevron-down.svg";
import { ReactComponent as ChevronUpIcon } from "../../../../stack/environment/icons/chevron-up.svg";

export const CONTENT_SECTION_CLASSNAME = "potential-section-content";
export const COLLAPSE_ICON_CLASSNAME = "potential-section-collapse-icon";
export const COLLAPSE_SECTION_CLASSNAME = "potential-section-collapse-section";

export default function PotentialCollapsibleSection({ title, Icon, children }) {
  const colors = useColors();
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div
      className={CONTENT_SECTION_CLASSNAME}
      style={{
        width: "100%",
        padding: "16px 16px 8px 16px",
        borderRadius: "8px",
        boxShadow: `0 8px 16px 0 ${colors.grey_16percent}`,
        backgroundColor: colors.common_white,
      }}
    >
      <Box display="flex" flexDirection="column" gap={1}>
        <Box
          height="24px"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          width="100%"
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            width="100%"
            onClick={() => setCollapsed((prev) => !prev)}
            sx={{ cursor: "pointer" }}
          >
            <Box display="flex" gap={"10px"} alignItems="center">
              <SvgToIcon
                IconLogo={Icon}
                width="24px"
                style={{ color: colors.primary_main }}
              />
              <Typography variant="subtitle1" color={colors.primary_main}>
                {title}
              </Typography>
            </Box>
            <span className={COLLAPSE_ICON_CLASSNAME}>
              <SvgToIcon
                IconLogo={collapsed ? ChevronDownIcon : ChevronUpIcon}
                width="20px"
                style={{ color: colors.active }}
              />
            </span>
          </Box>
        </Box>
        <span className={COLLAPSE_SECTION_CLASSNAME}>
          <Collapse in={!collapsed}>{children}</Collapse>
        </span>
      </Box>
    </div>
  );
}
